export enum FocusModes {
  ONLY,
  SKIP,
}
